"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var Config_1 = require("../Config");
var METHOD;
(function (METHOD) {
    METHOD["POST"] = "post";
    METHOD["GET"] = "get";
    METHOD["PUT"] = "put";
    METHOD["PATCH"] = "patch";
    METHOD["DELETE"] = "delete";
})(METHOD = exports.METHOD || (exports.METHOD = {}));
var ConnectedModel = /** @class */ (function () {
    function ConnectedModel(endpoint, auth) {
        var _this = this;
        this.model = [];
        this.getBaseUrl = function () {
            switch (Config_1.config.getOption('mode')) {
                case Config_1.MODE.MOCK:
                    return 'http://localhost:3000/v2';
                case Config_1.MODE.QA:
                    return 'https://qa-api.trunkrs.app/v2';
                case Config_1.MODE.DEVELOPMENT:
                    return 'https://staging-api.trunkrs.app/v2';
                case Config_1.MODE.PRODUCTION:
                    return 'https://api.trunkrs.app/v2';
                default:
                    return 'https://staging-api.trunkrs.app/v2';
            }
        };
        this.makeRequest = function (endpoint, method, payload, Authorization) { return __awaiter(_this, void 0, void 0, function () {
            var params, result, access, reattempt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            baseURL: this.getBaseUrl() + endpoint,
                            headers: {
                                Authorization: Authorization,
                            },
                            method: method,
                        };
                        if (method === METHOD.GET) {
                            Object.assign(params, {
                                params: payload,
                            });
                        }
                        else {
                            Object.assign(params, {
                                data: payload,
                            });
                        }
                        return [4 /*yield*/, axios_1.default(params)];
                    case 1:
                        result = _a.sent();
                        if (!(result.status === 401 && this.auth)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.auth.checkAccess()];
                    case 2:
                        access = _a.sent();
                        if (!access) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.makeRequest(endpoint, method, payload)];
                    case 3:
                        reattempt = _a.sent();
                        return [2 /*return*/, reattempt.data];
                    case 4:
                        if (result.status > 304) {
                            throw Error(result.statusText);
                        }
                        return [2 /*return*/, result.data];
                }
            });
        }); };
        this.find = function () {
            return _this.makeRequest(_this.endpoint, METHOD.GET, {}).then(function (results) {
                _this.model = results;
                return _this.model;
            });
        };
        this.endpoint = endpoint;
        if (auth) {
            this.auth = auth;
        }
    }
    return ConnectedModel;
}());
exports.ConnectedModel = ConnectedModel;
